// extracted by mini-css-extract-plugin
export default {"root":"StoreClusterForm_root__lfzRZ"};